import { useMemo } from "react";
import { useSession } from "next-auth/react";
import { TYPO } from "styles/Typo";
import useIsDetailLoading from "states/detailLoading";
import { KOREA } from "utils/constant/ITME_INFO";

function InterestNoti({
  isMobile,
  detailData,
}: {
  isMobile: boolean;
  detailData: any;
}) {
  const { data: session }: any = useSession();
  const isLoading = useIsDetailLoading();
  const isInterested = useMemo(() => {
    if (session && session.user) {
      return session.user?.interest.length > 0;
    }
  }, [session]);
  if (
    isInterested ||
    isLoading ||
    detailData?.LOC !== KOREA ||
    detailData?.CAT !== "Stock"
  )
    return null;
  return (
    <div className={``}>
      <div className="flex flex-col items-end">
        <div
          className=""
          style={{
            padding: isMobile ? "0 110px" : "0 72px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="8"
            viewBox="0 0 20 8"
            fill="none"
          >
            <path d="M20 8L10 0L0 8H20Z" fill="#3182F6" fill-opacity="0.15" />
          </svg>
        </div>
        <div
          className="flex flex-col px-6 py-[14px] w-full"
          style={{
            background: "rgba(49, 130, 246, 0.15)",
          }}
        >
          <p className={`${TYPO.TYPO8_RG} text-gray70`}>왜 올랐지?</p>
          <p className={`${TYPO.TYPO6_MD} text-blue60`}>
            관심 등록하면 최신 소식 알려드려요
          </p>
        </div>
      </div>
    </div>
  );
}

export default InterestNoti;
